/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

(function () {
  "use strict";

  // Theme analytics for Shopify design mode
  function sendThemeAnalytics() {
    if (
      window.Shopify &&
      window.Shopify.theme &&
      navigator?.sendBeacon &&
      window.Shopify.designMode
    ) {
      const themeData = new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme?.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      });

      navigator.sendBeacon(
        "https://api.archetypethemes.co/api/beacon",
        themeData
      );
    }
  }

  // Helper function for DOM ready
  function onDOMReady(callback) {
    if (document.readyState !== "loading") {
      callback();
    } else {
      document.addEventListener("DOMContentLoaded", callback);
    }
  }

  // Australia page description toggle
  function initAustraliaPageToggle() {
    const textSection = document.querySelector(".custom-text-section");
    const toggleButton = textSection?.querySelector(".toggle-button-aus");

    if (!textSection || !toggleButton) return;

    toggleButton.addEventListener("click", function () {
      const isExpanded = textSection.classList.toggle("expanded");
      textSection.classList.toggle("collapsed", !isExpanded);
      toggleButton.textContent = isExpanded ? "Read Less" : "Read More";
    });
  }

  // Image loading handler
  function handleImageLoading() {
    const images = document.querySelectorAll(".image-element");

    function imageLoaded(img) {
      img.classList.remove("image-loading");
      img.classList.add("loaded");
    }

    // Process existing images
    images.forEach((img) => {
      if (img.complete) {
        imageLoaded(img);
      } else {
        img.addEventListener("load", () => imageLoaded(img));
        img.addEventListener("error", () =>
          img.classList.remove("image-loading")
        );
      }
    });

    // Observe for dynamically added images
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches(".image-element")) {
            if (node.complete) {
              imageLoaded(node);
            } else {
              node.addEventListener("load", () => imageLoaded(node));
              node.addEventListener("error", () =>
                node.classList.remove("image-loading")
              );
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize everything
  onDOMReady(function () {
    sendThemeAnalytics();
    initAustraliaPageToggle();
    // handleImageLoading(); // Uncomment when needed

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

// Method 5: Simple version for Shopify themes
document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on homepage
  if (
    window.location.pathname === "/" ||
    document.body.classList.contains("template-index")
  ) {
    // Create style element
    const style = document.createElement("style");
    style.innerHTML = `
      .site-nav__link--icon {
        color: white !important;
      }
      .header-wrapper.header-wrapper--overlay.header-wrapper--compressed .site-nav__link--icon {
        color: white !important;
      }
      .site-nav__link{
        color: white !important;
      }
      .btn--close-search .icon path{
        stroke: white !important;
      }
      .cart-link__bubble:before {
        background-color: white;
      }
      .cart-link__bubble-num{
        color: #1E201E !important;
      }
    `;
    document.head.appendChild(style);
  }

  if (
    window.location.pathname !== "/"
  ) {
    // Create style element
    const style = document.createElement("style");
    style.innerHTML = `
      .site-header__element {
        background-color: white;
      }
    `;
    document.head.appendChild(style);
  }
});
